import React, { useState, useEffect, useContext} from 'react';
import MUIDataTable from 'mui-datatables';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
    Card,
    Stack,
    Alert,
    Button,
    Container,
    Typography,
    MenuItem,  
    ListItemIcon, 
    ListItemText,
    AlertTitle
  } from '@mui/material';

import { ThemeProvider } from '@mui/material/styles';
import Theme from '../../components/Button';

import {api, reiniciarToken, consMesa, excluirMesa} from '../../services/api';
// context
import { AuthContext } from '../../contexts/auth';  

import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import Iconify from '../../components/Iconify';

export default function ConsultaMesa() {
  
  const { logout } = useContext(AuthContext);
  const [dados, setData] = useState([]);

  const getMesas = async () => {
    
    const retorno = await reiniciarToken();
    if(retorno.erro === true) {
      if (retorno.mensagem === 'O Token é inválido!' || retorno.mensagem === 'Acesso negado!'){
        logout();
      }
    }else{
      localStorage.setItem("token", retorno.data.token);
      api.defaults.headers.Authorization = `Bearer ${retorno.data.token}`;
    }

    const response = await consMesa();
    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }
    }else {
      response.data.forEach((valores) => {
        setData(dados => [...dados, {id_mesa: valores.id_mesa, 
                                     codigo_mesa: valores.codigo_mesa,
                                     descricao: valores.descricao}]);
      });
    }; 
  }

  useEffect(() => {
    setData([]);
    getMesas();
  },[]) 

  const [status, setStatus] = useState({
    type: '',
    mensagem: ''
  }) 
  
  
  const excluiMesa = async (id) => {
    const response = await excluirMesa(id);

    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }else {
        setStatus({
          type: "erro",
          mensagem: response.mensagem
        })
      }
    }else {
      setStatus({
        type: "success",
        mensagem: response.data.mensagem
      })
      setData([]);
      getMesas();
    }; 
  } 

  const columns = [{name: "Ação",
                    options: {
                      filter: false,
                      sort: false,
                      empty: true,
                      customBodyRenderLite: (dataIndex, rowIndex) =>  {
                        return (
                          <> 
                            <MenuItem onClick={() => excluiMesa(dados[dataIndex].id_mesa)} sx={{ color: 'text.secondary' }}>
                              <ListItemIcon>
                                  <Iconify icon="eva:trash-2-outline" width={24} height={24} />
                              </ListItemIcon>
                              <ListItemText primary="Excluir" primaryTypographyProps={{ variant: 'body2' }} />
                            </MenuItem>

                            <MenuItem component={RouterLink} to={`/mesa/editar/${dados[dataIndex].id_mesa}`} sx={{ color: 'text.secondary' }}>
                              <ListItemIcon>
                                  <Iconify icon="eva:edit-fill" width={24} height={24} />
                              </ListItemIcon>
                              <ListItemText primary="Alterar" primaryTypographyProps={{ variant: 'body2' }} />
                            </MenuItem>
                          </> 
                        );
                      }
                    }
                  }
                  ,{name:"id_mesa", label: "ID"} 
                  ,{name:"codigo_mesa", label: "Código Mesa"} 
                  ,{name:"descricao", label: "Descrição"}
                  ];

  const options = {
    filterType: "dropdown",
    tableBodyHeight: "100%",
    selectableRows: "none",
    responsive: "standard",
  };             
                    
  return (
    <Page title="Mesa">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Consulta de Mesas
          </Typography>
          <ThemeProvider theme={Theme}>
            <Button variant="contained" color="neutral" component={RouterLink} to="/mesa/cadastrar" startIcon={<Iconify icon="eva:plus-fill" />}>
              Nova Mesa
            </Button>
          </ThemeProvider>
        </Stack>
        <Card>
            <Stack spacing={3}>
              {status.type === 'erro' ? <Alert severity="error"><AlertTitle>Erro</AlertTitle>{status.mensagem}</Alert> : ""}
              {status.type === 'success' ? <Alert severity="success"><AlertTitle>Sucesso</AlertTitle>{status.mensagem}</Alert> : ""}
            </Stack > 
            <Scrollbar>
              <MUIDataTable
                  data={Object.values(dados)}
                  columns={columns}  
                  options={options} 
              />
            </Scrollbar>
        </Card>
      </Container>  
    </Page>  
  );
}

